import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { GenCartItemValidationWarningComponent } from './cart-item-validation-warning.component';

@NgModule({
  imports: [CommonModule, RouterModule, I18nModule, UrlModule, IconModule],
  exports: [GenCartItemValidationWarningComponent],
  declarations: [GenCartItemValidationWarningComponent],
})
export class GenCartItemValidationWarningModule {} // TODO: remove this module export as soon as it is a part of public API
